export default {
  menu: 'Profile',
  title: 'Profile',
  dynamicTitle: 'Profile {name}',

  general: {
    details: {
      dynamicCompany: 'Company {company}'
    },

    importantData: {
      balance: 'Balance',
      score: 'Point',
      character: 'User Group'
    },

    actions: {
      transactions: 'Financial Turnover',
      addresses: 'Addresses',
      activeSessions: 'Active sessions',
      receivedEvents: 'Incoming messages',
      sentEvents: 'Sent messages',
      customize: 'System Personalization'
    },

    notifications: {
      edit: {
        success: 'Updating the information succeed',
        error: 'Updating the information failed'
      },

      revokeSession: {
        success: 'Active session successfully revoked',
        error: 'Revoke active session has error'
      },

      parseError: {
        required: 'Required Fields are Missing'
      }
    }
  },

  edit: {
    title: 'Edit Profile Information',

    labels: {
      gender: 'Gender',
      base: 'Basic',

      company: {
        name: 'Company Name',
        ownerName: 'Name of purchaser responsible',
        phoneNumber: 'Purchasing Mobile Number',
        email: 'Company Email'
      },

      user: {
        name:'First Name',
        family: 'Last Name',
        phoneNumber: 'Phone Number',
        email: 'Email',
        telegramToken: 'Telegram Token'
      }
    },

    validators: {
      name: 'Name field is not valid',
      family: 'Last Name field is not valid',
      companyName: 'Company Name field is missing',
      phoneNumber: 'Phone Number field is not valid',
      email: 'Email field is not valid'
    }
  },

  address: {
    title: 'Address',

    general: {
      labels: {
        name: 'Address Name',
        country: 'Country',
        province: 'Province',
        city: 'City',
        address: 'Postal address',
        plaque: 'Plaque',
        postalCode: 'Postal code',
        delete: 'Delete',
        save: 'Save',

        receiver: {
          info: 'Recipient Information',
          name: 'Recipient Name',
          family: 'Recipient Last Name',
          phoneNumber: 'Recipient Phone Number'
        }
      },

      description: {
        noAddress: 'No Addresses registered!'
      },

      validators: {
        city: 'City Name Field is Missing',
        province: 'Province Name Field is Missing',
        name: 'Name Field is Not Valid',
        nameCantEmpty: 'Name Field is Missing',
        address: 'Address Field is Not Valid',
        addressCantEmpty: 'Address Field is Missing',
        plaque: 'Plaque Field is Not Valid',
        postalCode: 'Postal Code Field is Not Valid',
        phoneNumber: 'Phone Number Field is Not Valid',
        receiver: {
          name: 'Recipient Name Field is Not Valid',
          nameCantEmpty: 'Recipient Name Field is Missing',
          family: 'Recipient Last Name Field is Not Valid',
          familyCantEmpty: 'Recipient Last Name Field is Missing',
          phoneNumber: 'Recipient Phone Number Field is Missing'
        }
      },

      notifications: {
        insert: {
          success: 'Creating the address succeed',
          error: 'Creating the address failed'
        },
        edit: {
          success: 'Updating the address succeed',
          error: 'Updating the address failed'
        },
        delete: {
          success: 'Deleting the address succeed',
          error: 'Deleting the address failed'
        }
      }
    },

    insert: {
      title: 'Add new address'
    },

    edit: {
      title: 'Edit Address'
    }
  },

  events: {
    seenTypes: {
      all: 'All',
      seen: 'Viewed',
      unSeen: 'Unseen'
    },

    list: {
      table: {
        header: {
          rowNumber: 'Row',
          creator: 'Sender',
          receiver: 'Receiver',
          subject: 'Subject',
          content: 'Content',
          seen: 'Viewing Status',
          type: 'Type',
          priority: 'Priority',
          createdAt: 'Post Date'
        }
      }
    },

    receive: {
      title: 'Incoming notifications'
    },

    send: {
      title: 'Messages sent'
    }
  },

  transactions: {
    title: 'Turnover',

    table: {
      header: {
        docNumber: 'Document Number',
        date: 'Date',
        documentation: 'Documents',
        price: 'Amount',
        balance: 'Inventory'
      }
    }
  },

  activeSessions: {
    title: 'Active sessions',

    labels: {
      maxSessionHelper: 'The maximum number of your active sessions can be {num}!',
      signIn: 'Sign in {date}',
      lastUsed: 'Last accessed on {date}',
      currentSession: 'Online',
      device: '{browser} on {device}',
      revoke: 'Revoke'
    },

    confirmations: {
      revoke: {
        title: 'Revoke active session confirmation',
        body: 'Are you sure to delete your active session with IP {ip}?'
      }
    }
  },

  customize: {
    title: 'System Personalization',

    labels: {
      theme: 'Select the desired theme'
    }
  }
}
